const keys = {
    zomatoApiKey: 'f7a5b883bef34e0148437a909b393a96',
    googleApiKey: 'AIzaSyCnqBDH_kR_tvH3FyRekQ5exthVZ6MOSQk'
}

export { keys }